import { c as _c } from "react/compiler-runtime";
import type { BreadcrumbList } from 'schema-dts';
import { LinkedDataJson } from 'src/shared/seo/LinkedDataJson';
import type { BreadcrumbSource } from '../constants';
import { getBreadcrumbSchema } from './utils';
type BreadcrumbLinkedDataProps = {
  id: string;
  prefixPath?: string;
  text: string;
  source: BreadcrumbSource;
  slug?: string;
};
export function BreadcrumbLinkedData(t0) {
  const $ = _c(8);
  const {
    id,
    prefixPath,
    text,
    source,
    slug
  } = t0;
  let t1;
  if ($[0] !== prefixPath || $[1] !== slug || $[2] !== source || $[3] !== text) {
    t1 = getBreadcrumbSchema({
      prefixPath,
      text,
      source,
      slug
    });
    $[0] = prefixPath;
    $[1] = slug;
    $[2] = source;
    $[3] = text;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== id || $[6] !== t1) {
    t2 = <LinkedDataJson id={id} schema={t1} />;
    $[5] = id;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}